











import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class UiPrescriptionButtonInvalid extends BaseComponent {
  @Prop({
    default: 'Salvar Prescrição',
  })
  public label: string;
}
